import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { IoChevronDown } from "react-icons/io5";

function NavDropdown({ label, items, textColor, iconColor, cardColor, borderColor, theme }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 transition-all uppercase text-xs sm:text-sm font-semibold tracking-wider cursor-pointer select-none"
        style={{ color: textColor, background: "transparent", border: "none" }}
      >
        <span>{label}</span>
        <IoChevronDown
          size={13}
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease-in-out",
            color: iconColor,
          }}
        />
      </button>

      {isOpen && (
        <div
          className="absolute left-1/2 -translate-x-1/2 mt-2 rounded-xl shadow-xl overflow-hidden z-[210] max-w-[calc(100vw-32px)] backdrop-blur-sm"
          style={{
            background: cardColor,
            border: `1.5px solid ${borderColor}`,
            minWidth: 220,
          }}
        >
          {items.map((item, idx) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setIsOpen(false)}
              title={item.title}
              className="block px-4 py-2.5 text-xs sm:text-sm font-medium uppercase hover:opacity-80 hover:bg-black/5 dark:hover:bg-white/5 transition-all"
              style={({ isActive }) => ({
                color: isActive ? iconColor : textColor,
                textDecoration: "none",
                borderBottom:
                  idx !== items.length - 1
                    ? theme === "dark"
                      ? "1px solid #343442"
                      : "1px solid #f2e4d0"
                    : "none",
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

export default NavDropdown;